import { graphql } from "msw";
import {
  mockCart,
  mockCartParcel,
  mockCartParcelItems,
  mockCartOrderSummary,
} from "./mockCart";
import {
  UpdateCartItemQuantityMutationVariables,
  UpdateCartItemQuantityMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  UpdateCartItemQuantityMutation,
  UpdateCartItemQuantityMutationVariables
>("UpdateCartItemQuantity", (req, res, ctx) => {
  const { quantity, id } = req.variables;

  const otherParcels = mockCartParcel.slice(1);
  const otherItems = mockCartParcelItems.slice(1);

  if (quantity === 10) {
    return res(
      ctx.data({
        updateCartItemQuantity: {
          __typename: "UserError" as const,
          message: "Something went wrong",
        },
      })
    );
  }

  return res(
    ctx.data({
      updateCartItemQuantity: {
        ...mockCart,
        itemsQuantitySum: quantity,
        parcels: [
          {
            ...mockCartParcel[0],
            items: [
              {
                ...mockCartParcel[0].items[0],
                id,
                quantity,
                totalPrice: {
                  amount:
                    mockCartParcel[0].items[0].totalPrice.amount * quantity,
                },
              },
              ...otherItems,
            ],
          },
          ...otherParcels,
        ],
        orderSummary: {
          ...mockCartOrderSummary,
          subtotalPrice: {
            __typename: "Money" as const,
            amount: 9999,
          },
          totalPrice: {
            __typename: "Money" as const,
            amount: 121212,
          },
        },
      },
    })
  );
});
